export default __webpack_public_path__ + "static/media/tv.697370be.svg";